module.exports = __webpack_public_path__ + "img/wechat.de2cd44c.png";